$(document).ready(function () {
    const COLOR_SLUGS = ['light-blue', 'black', 'blue', 'green', 'orange', 'red', 'white', 'yellow', 'pink', 'purple', 'clear'];
    const BUMPER_COLOR_SLUGS = ['black', 'blue', 'green', 'orange', 'red', 'white', 'yellow'];
    const GRAPHIC_COLOR_SLUGS = ['black', 'green', 'light-blue', 'blue', 'orange', 'pink', 'purple', 'red', 'white', 'yellow'];
    const GEAR_COLOR_SLUGS = ['black', 'blue', 'clear', 'green', 'orange', 'red'];
    const RAIL_COLOR_SLUGS = ['black', 'blue', 'clear', 'green', 'orange', 'red'];
    const IMAGE_DRAW_ORDER = ['bike', 'track', 'skid', 'rack', 'ski', 'ski-handle', 'graphic', 'bumper', 'gear'];
    const RACK_MATERIAL_SLUGS = ['alum', 'carbon'];
    const imageCache = new Map();
    const preloadedModels = new Set();
    let renderTimeout = null;
    let lastRenderSignature = null;

    function normalizeValue(value) {
        return (value || '').toString().trim().toLowerCase();
    }

    function getPropertyValue(name) {
        const checked = $(`input[name="properties[${name}]"]:checked`).val();
        if (checked) {
            return checked;
        }
        return $(`select[name="properties[${name}]"]`).val() || '';
    }

    function getColorSlug(value, fallbackColor) {
        const normalized = normalizeValue(value);
        const colorName = COLOR_SLUGS.find((candidate) => normalized.includes(candidate.replace('-', ' ')));
        return colorName || fallbackColor;
    }

    function getCurrentModelCode() {
        const configured = window.YETI_KIT_CONFIG?.modelCode;
        if (configured) {
            return configured;
        }

        const path = normalizeValue(window.location.pathname || '');
        if (path.includes('129nxg') || path.includes('129el')) {
            return '129el';
        }
        if (path.includes('137')) {
            return '137';
        }
        if (path.includes('129')) {
            return '129';
        }
        if (path.includes('126')) {
            return '126';
        }
        if (path.includes('120')) {
            return '120';
        }

        const title = normalizeValue($('.mak__pdp-title h2').first().text());
        if (title.includes('129nxg') || title.includes('129el')) {
            return '129el';
        }
        if (title.includes('137')) {
            return '137';
        }
        if (title.includes('129')) {
            return '129';
        }
        if (title.includes('126')) {
            return '126';
        }
        return '120';
    }

    function getRackMaterialKey() {
        const rackValue = normalizeValue(getPropertyValue('Cargo Rack'));
        if (!rackValue || rackValue.includes('no cargo rack') || rackValue === 'none') {
            return null;
        }
        if (rackValue.includes('carbon')) {
            return 'carbon';
        }
        if (rackValue.includes('alum') || rackValue.includes('installed')) {
            return 'alum';
        }
        return null;
    }

    function getImageContext() {
        const modelCode = getCurrentModelCode();
        const chassisValue = normalizeValue(getPropertyValue('Chassis'));
        const skidValue = normalizeValue(getPropertyValue('Skid') || getPropertyValue('Suspension'));

        return {
            modelCode,
            chassisKey: chassisValue.includes('short') ? 'short' : 'standard',
            skidKey: skidValue.includes('one') ? 'one' : 'elka',
            skiHandleColor: getColorSlug(getPropertyValue('Ski Handle Color'), 'black'),
            skiBoardColor: getColorSlug(getPropertyValue('Ski Board Color'), 'black'),
            bumperColor: getColorSlug(getPropertyValue('Bumper Color'), 'black'),
            graphicColor: getColorSlug(getPropertyValue('Graphic Color'), 'white'),
            gearColor: getColorSlug(getPropertyValue('Gear Color'), 'clear'),
            railColor: getColorSlug(getPropertyValue('Rail Color'), 'black'),
            rackKey: getRackMaterialKey(),
        };
    }

    function resolveShadowImage(context) {
        if (context.modelCode === '120') {
            return 'shadow.120.png';
        }
        if (context.modelCode === '129el') {
            return `shadow.129el.${context.skidKey}.png`;
        }
        if (context.modelCode === '137') {
            return `shadow.137.${context.skidKey}.png`;
        }
        return `shadow.${context.modelCode}.${context.chassisKey}-${context.skidKey}.png`;
    }

    function resolveTrackImage(context) {
        if (context.modelCode === '137') {
            return `track.137.${context.skidKey}.png`;
        }
        return `track.${context.modelCode}.png`;
    }

    function resolveSkidImage(context) {
        if (context.modelCode === '126' || context.modelCode === '129') {
            return context.skidKey === 'one' ? `skid.126_129.one.${context.railColor}.png` : 'skid.126_129.png';
        }
        if (context.modelCode === '129el') {
            return context.skidKey === 'one' ? `skid.129el.one.${context.railColor}.png` : 'skid.129el.png';
        }
        if (context.modelCode === '120') {
            return `skid.120.${context.railColor}.png`;
        }
        if (context.modelCode === '137') {
            return context.skidKey === 'one' ? `skid.137.one.${context.railColor}.png` : 'skid.137.png';
        }
        return null;
    }

    function resolveLayerSources(context) {
        const is129el = context.modelCode === '129el';
        const colorPrefix = is129el ? '129el' : context.chassisKey;
        const skiPrefix = is129el ? '129el.' : '';
        const gearPrefix = is129el ? '129el' : 'wide';

        return {
            bike: `bike.${is129el ? '129el' : 'wide'}.png`,
            shadow: resolveShadowImage(context),
            track: resolveTrackImage(context),
            skid: resolveSkidImage(context),
            rack: context.rackKey ? `rack.${context.chassisKey}.${context.rackKey}.png` : null,
            'ski-handle': `ski-handle.${skiPrefix}${context.skiHandleColor}.png`,
            ski: `ski.${skiPrefix}${context.skiBoardColor}.png`,
            bumper: `bumper.${colorPrefix}.${context.bumperColor}.png`,
            graphic: `graphic.${colorPrefix}.${context.graphicColor}.png`,
            gear: `gear.${gearPrefix}.${context.gearColor}.png`,
        };
    }

    function buildPreloadFilenames(modelCode) {
        const filenames = new Set();
        const is129el = modelCode === '129el';

        filenames.add(`bike.${is129el ? '129el' : 'wide'}.png`);

        if (modelCode === '120') {
            filenames.add('shadow.120.png');
            filenames.add('track.120.png');
            RAIL_COLOR_SLUGS.forEach((color) => filenames.add(`skid.120.${color}.png`));
        } else if (modelCode === '129el') {
            filenames.add('shadow.129el.elka.png');
            filenames.add('shadow.129el.one.png');
            filenames.add('track.129el.png');
        } else if (modelCode === '137') {
            filenames.add('track.137.elka.png');
            filenames.add('track.137.one.png');
            filenames.add('shadow.137.elka.png');
            filenames.add('shadow.137.one.png');
            filenames.add('skid.137.png');
            RAIL_COLOR_SLUGS.forEach((color) => filenames.add(`skid.137.one.${color}.png`));
        } else {
            filenames.add(`track.${modelCode}.png`);
            ['short', 'standard'].forEach((chassis) => {
                ['elka', 'one'].forEach((skid) => {
                    filenames.add(`shadow.${modelCode}.${chassis}-${skid}.png`);
                });
            });
            filenames.add('skid.126_129.png');
            RAIL_COLOR_SLUGS.forEach((color) => filenames.add(`skid.126_129.one.${color}.png`));
        }

        if (is129el) {
            BUMPER_COLOR_SLUGS.forEach((color) => filenames.add(`bumper.129el.${color}.png`));
            GRAPHIC_COLOR_SLUGS.forEach((color) => filenames.add(`graphic.129el.${color}.png`));
            GEAR_COLOR_SLUGS.forEach((color) => filenames.add(`gear.129el.${color}.png`));
            BUMPER_COLOR_SLUGS.forEach((color) => filenames.add(`ski-handle.129el.${color}.png`));
            BUMPER_COLOR_SLUGS.forEach((color) => filenames.add(`ski.129el.${color}.png`));
        } else {
            ['short', 'standard'].forEach((prefix) => {
                BUMPER_COLOR_SLUGS.forEach((color) => filenames.add(`bumper.${prefix}.${color}.png`));
                GRAPHIC_COLOR_SLUGS.forEach((color) => filenames.add(`graphic.${prefix}.${color}.png`));
            });
            GEAR_COLOR_SLUGS.forEach((color) => filenames.add(`gear.wide.${color}.png`));
            BUMPER_COLOR_SLUGS.forEach((color) => filenames.add(`ski-handle.${color}.png`));
            BUMPER_COLOR_SLUGS.forEach((color) => filenames.add(`ski.${color}.png`));
        }

        ['short', 'standard'].forEach((chassis) => {
            RACK_MATERIAL_SLUGS.forEach((material) => filenames.add(`rack.${chassis}.${material}.png`));
        });

        return Array.from(filenames);
    }

    function getImageBaseUrl() {
        return 'https://cdn.shopify.com/s/files/1/0671/9163/6163/files/';
    }

    function getImageUrl(filename) {
        const baseUrl = getImageBaseUrl();
        if (!baseUrl || !filename) {
            return null;
        }
        return `${baseUrl}${encodeURIComponent(filename)}`;
    }

    function loadImage(url) {
        if (!url) {
            return Promise.resolve(null);
        }
        if (imageCache.has(url)) {
            return imageCache.get(url);
        }
        const imagePromise = new Promise((resolve) => {
            const image = new Image();
            image.onload = function () {
                resolve(image);
            };
            image.onerror = function () {
                resolve(null);
            };
            image.src = url;
        });
        imageCache.set(url, imagePromise);
        return imagePromise;
    }

    function loadAllLayerImages(layerSources) {
        const layerEntries = [
            ...IMAGE_DRAW_ORDER.map((layer) => ({ layer, filename: layerSources[layer] })),
            { layer: 'shadow', filename: layerSources.shadow },
        ].filter((entry) => Boolean(entry.filename));

        return Promise.all(layerEntries.map((entry) => loadImage(getImageUrl(entry.filename)).then((image) => ({ layer: entry.layer, image }))));
    }

    function drawContainedImage(ctx, image, targetWidth, targetHeight) {
        const sourceWidth = image.naturalWidth || image.width || 1;
        const sourceHeight = image.naturalHeight || image.height || 1;
        const scale = Math.min(targetWidth / sourceWidth, targetHeight / sourceHeight);
        const drawWidth = Math.round(sourceWidth * scale);
        const drawHeight = Math.round(sourceHeight * scale);
        const dx = Math.round((targetWidth - drawWidth) / 2);
        const dy = Math.round((targetHeight - drawHeight) / 2);
        ctx.drawImage(image, dx, dy, drawWidth, drawHeight);
    }

    function drawLayersToCanvas(canvas, loadedLayers) {
        if (!canvas) {
            return;
        }

        const availableImages = loadedLayers.filter((entry) => entry.image).map((entry) => entry.image);
        if (!availableImages.length) {
            return;
        }

        const maxWidth = Math.max(...availableImages.map((image) => image.naturalWidth || image.width || 1));
        const maxHeight = Math.max(...availableImages.map((image) => image.naturalHeight || image.height || 1));
        canvas.width = Math.max(1, maxWidth);
        canvas.height = Math.max(1, maxHeight);
        const ctx = canvas.getContext('2d');

        if (!ctx) {
            return;
        }

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        IMAGE_DRAW_ORDER.forEach((layer) => {
            const record = loadedLayers.find((entry) => entry.layer === layer);
            if (record?.image) {
                drawContainedImage(ctx, record.image, canvas.width, canvas.height);
            }
        });

        const shadow = loadedLayers.find((entry) => entry.layer === 'shadow');
        if (shadow?.image) {
            ctx.save();
            ctx.globalCompositeOperation = 'multiply';
            ctx.globalAlpha = 0.6;
            drawContainedImage(ctx, shadow.image, canvas.width, canvas.height);
            ctx.restore();
        }
    }

    function preloadRelevantImages(context) {
        const modelCode = context.modelCode;
        if (preloadedModels.has(modelCode)) {
            return;
        }
        const filenames = buildPreloadFilenames(modelCode);
        filenames.forEach((filename) => loadImage(getImageUrl(filename)));
        preloadedModels.add(modelCode);
    }

    function applyCompositeToGallery(loadedLayers) {
        if (!loadedLayers?.length) {
            return;
        }

        const mainCanvas = document.querySelector('.mak_configurator-canvas');
        const popupCanvas = document.querySelector('.mak_popup-configurator-canvas');

        drawLayersToCanvas(mainCanvas, loadedLayers);
        drawLayersToCanvas(popupCanvas, loadedLayers);

        if (mainCanvas) {
            $('.mak-magnifier').addClass('is-canvas-active');
        }
        if (popupCanvas) {
            $('.mak_popup_magnifier').addClass('is-canvas-active');
        }
    }

    function renderConfiguratorImage() {
        const baseUrl = getImageBaseUrl();
        if (!baseUrl) {
            return;
        }

        const context = getImageContext();
        preloadRelevantImages(context);
        const layerSources = resolveLayerSources(context);
        const renderSignature = JSON.stringify(layerSources);
        lastRenderSignature = renderSignature;
        console.log(context, layerSources);

        loadAllLayerImages(layerSources).then((loadedLayers) => {
            if (lastRenderSignature !== renderSignature) {
                return;
            }
            applyCompositeToGallery(loadedLayers);
        });
    }

    function scheduleRender() {
        clearTimeout(renderTimeout);
        renderTimeout = setTimeout(function () {
            renderConfiguratorImage();
        }, 50);
    }

    $('#mak_flip').on('click', function () {
        $('.mak_configurator-canvas').toggleClass('image__flip');
    });

    $('#mak_flip-new').on('click', function () {
        $('.mak_popup-configurator-canvas').toggleClass('image__flip');
    });

    const mtnTopSkis = $('#ski-mtn-top, #ski-mtn-top-925');

    mtnTopSkis.click(function () {
        $('#spindle-carbon').click()
    });
    $('#spindle-aluminum').click(function () {
        $('#ski-yeti').click()
    });
    $('#yeti-129-ss').click(function () {
        if ($('#brake-fr-mt').is(':checked')) $('#brake-ss').click()
    });
    $('#brake-ss').click(function () {
        if ($('#yeti-129-fr').is(':checked')) $('#yeti-129-ss').click()
    });
    $('#yeti-129-fr').click(function () {
        if ($('#brake-ss').is(':checked')) $('#brake-fr-mt').click()
    });
    $('#brake-fr-mt').click(function () {
        if ($('#yeti-129-ss').is(':checked')) $('#yeti-129-fr').click()
    });
    mtnTopSkis.click(function () {
        $('#handle-color-black, #board-color-black').click()
    });
    $('#handle-color-orange, #handle-color-blue, #handle-color-red, #handle-color-green, #handle-color-white, #handle-color-yellow , #board-color-orange, #board-color-blue, #board-color-red, #board-color-green, #board-color-white, #board-color-yellow, #bumper-color-orange, #bumper-color-blue').click(function () {
        $('#ski-yeti').click()
    });
    const currentModel = getCurrentModelCode();
    const blackRail = $('#rail-color-black');
    const nonBlackRailColors = $("#rail-color-orange, #rail-color-blue, #rail-color-red, #rail-color-green, #rail-color-grey");
    const elkaSkids = $('#skid-elka-3, #skid-elka-5');
    const oneSkid = $('#skid-one');

    if (currentModel !== '120') {
        nonBlackRailColors.click(function () {
            oneSkid.click();
        });
        elkaSkids.click(function () {
            blackRail.click();
        });
    }

    const customColors = $("#handle-color-orange, #handle-color-blue, #handle-color-red, #handle-color-green, #handle-color-white, #handle-color-yellow , #board-color-orange, #board-color-blue, #board-color-red, #board-color-green, #board-color-white, #board-color-yellow, #bumper-color-orange, #bumper-color-blue, #bumper-color-red, #bumper-color-green, #bumper-color-white, #bumper-color-yellow, #graphic-color-black, #graphic-color-orange, #graphic-color-blue, #graphic-color-red, #graphic-color-green, #gear-color-black, #gear-color-orange, #gear-color-blue, #gear-color-red, #gear-color-green, #rail-color-orange, #rail-color-blue, #rail-color-red, #rail-color-green, #rail-color-grey");
    const standardColors = $('#handle-color-black, #board-color-black, #bumper-color-black, #gear-color-clear, #rail-color-black, #graphic-color-white');
    customColors.click(function () {
        $('#optional').click()
    });
    $('#standard').click(function () {
        standardColors.click()
    });
    function updateBrakeOptions() {
        if ($('#standard').is(':checked')) $('#custom-requires, .custom-color-require').show();
        else $('#custom-requires, .custom-color-require').hide();

        if (mtnTopSkis.is(':checked')) $('#handle-requires, #board-requires').show();
        else $('#handle-requires, #board-requires').hide();

        if (currentModel !== '120') {
            if (nonBlackRailColors.is(':checked')) $('#rail-elka-requires').show();
            else $('#rail-elka-requires').hide();
            if (elkaSkids.is(':checked')) $('#rail-color-requires').show();
            else $('#rail-color-requires').hide();
        } else $('#rail-elka-requires, #rail-color-requires').hide();
    }

    $("select[name^='properties'], input[name^='properties']").on(
        "change",
        function () {
            updateBrakeOptions();
            scheduleRender();
        }
    );

    updateBrakeOptions();
    scheduleRender();
});
